import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { configuration } from '../../../core/configuration';
import { EndpointRequester } from '../../../requesters/async-validators/endpoint.requester';
import { ExpositionEndpointMetadataEntity } from './exposition-endpoint-metadata.entity';

export enum EndpointMetadataFormControls {
	AccessPoint = 'access-point',
	Title = 'title',
	Details = 'details',
	SynthesisType = 'access-mode',
}

@Injectable()
export class ExpositionEndpointMetadataForm {
	public form: FormGroup;

	public constructor(
		protected readonly fb: FormBuilder,
		private readonly endpointRequester: EndpointRequester
	) {
		this.form = this.fb.group({
			[EndpointMetadataFormControls.AccessPoint]: [
				'',
				[
					Validators.required,
					Validators.maxLength(configuration.maxLengthAccessPoint),
					Validators.minLength(configuration.minLengthAccessPoint),
					Validators.pattern('^[a-zA-Z][a-zA-Z0-9_]*$'),
				],
			],
			[EndpointMetadataFormControls.Title]: [
				'',
				[
					Validators.required,
					Validators.maxLength(configuration.maxLengthLabel),
				],
			],
			[EndpointMetadataFormControls.Details]: [
				'',
				[Validators.maxLength(configuration.maxLengthDescription)],
			],
			[EndpointMetadataFormControls.SynthesisType]: [
				false,
				[Validators.required],
			],
		});
	}

	public extract(): Partial<ExpositionEndpointMetadataEntity> {
		if (!this.form) {
			throw new Error('no form found');
		}
		const formValues = this.form.value;
		return ExpositionEndpointMetadataEntity.build({
			accessPoint: formValues[EndpointMetadataFormControls.AccessPoint] ?? -1,
			title: formValues[EndpointMetadataFormControls.Title] ?? '',
			details: formValues[EndpointMetadataFormControls.Details] ?? '',
			synthesisType: formValues[EndpointMetadataFormControls.SynthesisType]
				? 'Additive'
				: 'Restrictive',
		});
	}

	public populate(
		config: Partial<ExpositionEndpointMetadataEntity> | null
	): void {
		if (config === null || config.id === undefined) {
			throw new Error('Invalid entity');
		}
		this.form.patchValue({
			[EndpointMetadataFormControls.AccessPoint]: config?.accessPoint ?? '',
			[EndpointMetadataFormControls.Title]: config?.title ?? '',
			[EndpointMetadataFormControls.Details]: config?.details ?? '',
			[EndpointMetadataFormControls.SynthesisType]:
				config?.synthesisType === 'Additive' ? true : false ?? false,
		});
		this.form.updateValueAndValidity();
	}
}
